import type { FC } from "react";

import * as React from "react";

import { ModulePreviewProvider } from "../../contexts";
import { Component, type ComponentProps } from "../Component";

export interface ModulePreviewProps {
	component: string;
	content: Record<string, unknown>;
	library: {
		components: Record<string, FC<Omit<ComponentProps, "libComponents">>>;
	};
}

function ModulePreview(props: ModulePreviewProps) {
	const {
		component,
		content,
		library: { components },
	} = props;

	if (!content) {
		return null;
	}

	return (
		<ModulePreviewProvider languageId={content.language as number}>
			<Component
				libComponents={components}
				component={component}
				{...content}
			/>
		</ModulePreviewProvider>
	);
}

export { ModulePreview };
